import React from 'react';
import HeroSection from './HeroSection';
import FeaturedProjects from './FeaturedProjects';
import TrustlessCard from './TrustlessCard';
import InnovatorsDashboard from './InnovatorsDashboard';
import RolesDashboard from './RolesDashboard';
import FutureSection from './FutureSection';
import ProblemSolutionSection from './ProblemSolutionSection';
import GlobalEmissionsHistory from './GlobalEmissionsHistory';
import UserGuide from './UserGuide';
const HomeComponent = () => {
  return (
    <div className='bg-white text-gray-800 min-h-screen'>
      {/* Hero Section with gradient background */}
      <HeroSection />

      
      {/*user guide*/}
      <UserGuide />
      {/* Roles Description
      <RolesDashboard />
       */}

      {/* Core Product Value Proposition */}
      <TrustlessCard />

      {/* Projects & Innovators Section */}
      <div className='max-w-7xl mx-auto py-16'>
        <div className='flex flex-col space-y-8'>
          {/* Featured Projects */}
          <FeaturedProjects />

          {/* Innovators Dashboard */}
          <InnovatorsDashboard />

          {/* Global Emissions History */}
          <GlobalEmissionsHistory />
        </div>
      </div>

      

      {/* Problem Solution Section */}
      <ProblemSolutionSection />

      {/* Call to Action */}
      <FutureSection />
    </div>
  );
};

export default HomeComponent;
